











import Vue from "vue";
export default Vue.extend({
  props: {
    element: {
      type: String,
      default: "span"
    },
    isActive: {
      type: Boolean
    }
  },
  data() {
    return {
      hover: false
    };
  },
  methods: {
    // mouse() {},
  }
});
